import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class ShiftParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
}

export class ShiftEmployeeParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    search?: string;
}